export const rollcallleaveaccurals = [
  {
    Id: 1001,
    Employee: "John Doe",
    Designation: "Software Engineer",
    Mobile: "123-456-7890",
    DOJ: "2021-06-01",
    CarryFrdLevs: 5,
    Accrued: 10,
    Taken: 3,
    Balance: 12,
  },
  {
    Id: 1002,
    Employee: "Jane Smith",
    Designation: "HR Manager",
    Mobile: "987-654-3210",
    DOJ: "2019-03-15",
    CarryFrdLevs: 7,
    Accrued: 15,
    Taken: 5,
    Balance: 17,
  },
  {
    Id: 1003,
    Employee: "Michael Johnson",
    Designation: "Project Manager",
    Mobile: "321-654-9870",
    DOJ: "2018-02-20",
    CarryFrdLevs: 6,
    Accrued: 12,
    Taken: 4,
    Balance: 14,
  },
  {
    Id: 1004,
    Employee: "Emily Davis",
    Designation: "Marketing Specialist",
    Mobile: "654-321-9870",
    DOJ: "2020-08-11",
    CarryFrdLevs: 8,
    Accrued: 14,
    Taken: 6,
    Balance: 16,
  },
  {
    Id: 1005,
    Employee: "David Wilson",
    Designation: "Sales Executive",
    Mobile: "789-012-3456",
    DOJ: "2022-01-01",
    CarryFrdLevs: 4,
    Accrued: 8,
    Taken: 2,
    Balance: 10,
  },
  {
    Id: 1006,
    Employee: "Olivia Brown",
    Designation: "Customer Support",
    Mobile: "567-890-1234",
    DOJ: "2017-07-05",
    CarryFrdLevs: 3,
    Accrued: 9,
    Taken: 1,
    Balance: 11,
  },
  {
    Id: 1007,
    Employee: "James Miller",
    Designation: "Software Developer",
    Mobile: "123-789-4560",
    DOJ: "2019-09-19",
    CarryFrdLevs: 5,
    Accrued: 13,
    Taken: 7,
    Balance: 11,
  },
  {
    Id: 1008,
    Employee: "Sophia Moore",
    Designation: "UI/UX Designer",
    Mobile: "432-567-8901",
    DOJ: "2020-04-10",
    CarryFrdLevs: 10,
    Accrued: 20,
    Taken: 9,
    Balance: 21,
  },
  {
    Id: 1009,
    Employee: "Daniel Taylor",
    Designation: "Data Analyst",
    Mobile: "345-678-9012",
    DOJ: "2016-11-25",
    CarryFrdLevs: 4,
    Accrued: 11,
    Taken: 3,
    Balance: 12,
  },
  {
    Id: 1010,
    Employee: "Ava Anderson",
    Designation: "Business Analyst",
    Mobile: "234-567-8903",
    DOJ: "2021-05-30",
    CarryFrdLevs: 6,
    Accrued: 9,
    Taken: 5,
    Balance: 10,
  },
  {
    Id: 1011,
    Employee: "Liam Garcia",
    Designation: "Content Writer",
    Mobile: "876-543-2109",
    DOJ: "2022-07-21",
    CarryFrdLevs: 7,
    Accrued: 16,
    Taken: 6,
    Balance: 17,
  },
  {
    Id: 1012,
    Employee: "Mia Martinez",
    Designation: "Operations Manager",
    Mobile: "543-210-8765",
    DOJ: "2021-10-15",
    CarryFrdLevs: 9,
    Accrued: 18,
    Taken: 8,
    Balance: 19,
  },
];
